<template>
  <div class="px-0.5">
    <textarea
      v-if="value"
      ref="textarea"
      :disabled="!editable"
      class="w-full p-2 rounded-lg bg-primary-lightest overflow-hidden"
      :class="{
        'h-8' : question.type.slug === QuestionType.CHECK_INPUT,
        'p-2 text-sm' : density === 'compact',
      }"
      :value="value"
      @input="handleChange"
    />
  </div>
</template>

<script lang="ts">
import {defineComponent} from "vue";
import {QuestionType} from "@/core/interfaces/survey/Survey";

export default defineComponent({
    name: 'SurveyBuiltInput',
    props: {
        question: {
            type: Object,
            required: true
        },
        editable: {
            type: Boolean,
            default: false
        },
        density: {
            type: String,
            default: 'normal'
        },
        value: {
            type: Array<string>,
            default: null
        }
    },
    emits: ['change'],
    data() {
        return {
            QuestionType
        };
    },
    watch: {
        async value() {
            await this.$nextTick();
            this.autoResize();
        }
    },
    mounted() {
        this.autoResize();
    },
    methods: {
        autoResize() {
            const textarea = this.$refs.textarea as HTMLTextAreaElement;

            if (!textarea) {
                return;
            }

            textarea.style.height = textarea.scrollHeight + 'px';
        },
        handleChange(event: Event): void {
            this.$emit('change', (event.target as HTMLTextAreaElement).value);
        }
    }
});
</script>
